import * as React from 'react';
import { PromptExit, navigate } from 'libs/router';
import { connect } from 'react-redux';

import BaseInfluencerAgencyPage from 'modules/influencers-agency/pages/BaseInfluencerAgencyPage';
import InfluencersAgencyCreateProfile from '../../components/influencers-agency-create-profile/InfluencersAgencyCreateProfile';
import InfluencersAgencyTitleBreadcrumb from '../../components/influencers-agency-title-breadcrumb/InfluencersAgencyTitleBreadcrumb';

import { hideConfirmModal, showConfirmModal } from 'redux-store/reducers/modal-reducer';

import { __t, applyTranslations } from 'utils/language';

import './influencers-agency-create-profile-page.scss';

applyTranslations(require('../../influencers-agencies-pages.i18n.json'));
applyTranslations(require('./influencers-agency-create-profile-page.i18n.json'));

import { Params } from 'types';

type OwnProps = {
  params: Params
}

type DispatchProps = {
  dispatchShowConfirmModal: (params) => void,
  dispatchHideConfirmModal: () => void
}

type Props = OwnProps & DispatchProps;

const MSG_KEY = 'influencers_agency_create_profile_page';

const InfluencersAgencyCreateProfilePage = ({ params, dispatchShowConfirmModal, dispatchHideConfirmModal }: Props) => {
  const agencyId = Number(params.id);

  const [isModified, setIsModified] = React.useState(false);

  const onCancel = () => {
    if (isModified) {
      dispatchShowConfirmModal({
        message: __t(`${MSG_KEY}.cancel_profile_creation_modal.message`),
        title: __t(`${MSG_KEY}.cancel_profile_creation_modal.title`),
        confirmButtonLabel: __t(`${MSG_KEY}.cancel_profile_creation_modal.confirm_btn`),
        cancelButtonLabel: __t(`${MSG_KEY}.cancel_profile_creation_modal.cancel_btn`),
        onConfirm: () => {
          dispatchHideConfirmModal();
          navigate.to(`/influencers-agencies/${agencyId}/settings/add-new-profiles`);
        },
        onCancel: dispatchHideConfirmModal
      });
    } else {
      navigate.to(`/influencers-agencies/${agencyId}/settings/add-new-profiles`);
    }
  };

  return (
    <BaseInfluencerAgencyPage
      agencyId={agencyId}
      documentTitle={__t('influencers_agencies_pages.create_new_profile')}
    >
      {
        isModified && <PromptExit
          type="page"
          message={__t(`${MSG_KEY}.cancel_profile_creation_modal.message`)}
          title={__t(`${MSG_KEY}.cancel_profile_creation_modal.title`)}
          actionButtonLabel={__t(`${MSG_KEY}.cancel_profile_creation_modal.confirm_btn`)}
          cancelButtonLabel={__t(`${MSG_KEY}.cancel_profile_creation_modal.cancel_btn`)}
        />
      }
      <div>
        <InfluencersAgencyTitleBreadcrumb
          title={__t('influencers_agency_create_profile_page.create_new_profile')}
          onCancel={onCancel}
        />
        <div className="influencers-agency-create-profile-page--info-text">
          {__t('influencers_agency_create_profile_page.info_text')}
        </div>
        <InfluencersAgencyCreateProfile
          agencyId={agencyId}
          onCancel={onCancel}
          setIsModified={(modifiedFlag) => setIsModified(modifiedFlag)}
        />
      </div>
    </BaseInfluencerAgencyPage>
  );
};

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchShowConfirmModal: (params) => dispatch(showConfirmModal(params)),
  dispatchHideConfirmModal: () => dispatch(hideConfirmModal())
});

export default connect(null, mapDispatchToProps)(InfluencersAgencyCreateProfilePage);
